import { Box, Flex, Text, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { AssignmentEditByCSVContainer } from 'packages/loanProduct/ui/AssignmentEditByCSVContainer';
import { AssignmentHeader } from 'packages/loanProduct/ui/AssignmentTemplate';
import 'borrower/borrower.scss';

export const AssignmentEditByCSVRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();

  let routeLevelError = false;

  return (
    <Box margin="0 auto" width="100%" maxWidth="1600px">
      <Box className="main">
        <Sentry.ErrorBoundary
          onError={() => {
            if (!routeLevelError && !toast.isActive(errorToastId)) {
              errorToastConfig.title = `Failed to load assignment edit by csv route`;
              routeLevelError = true;
              toast(errorToastConfig);
              navigate('/');
            }
          }}
        >
          <Flex direction="column">
            <Flex justify="space-between" mb="24px">
              <AssignmentHeader editMode />
            </Flex>
            <Text fontSize="lg" mb="32px">
              To assign receivables, upload .CSV files to the relevant loan
              product & credit facility grouping(s) below. .CSVs should only
              contain receivable IDs. Assigning by .CSV will reset any prior
              assignment proposals from assign by strategy and/or assign by
              individual receivable.
            </Text>
          </Flex>
          <AssignmentEditByCSVContainer />
        </Sentry.ErrorBoundary>
      </Box>
    </Box>
  );
};
